import { Box } from '@mui/material';
import { SelectedProvider, convertPublicProfileToSelectedProviderType } from '@uplift/pages';
import { useProfileContext } from '../profile.context';
import { useStates } from '@uplift/queries';

export const ProfileInReviewPreview: React.VFC = () => {
  const { states } = useStates();
  const { profile } = useProfileContext();

  return (
    <Box>
      <SelectedProvider
        // use first license state for preview
        stateId={profile.licenses?.[0]?.stateId}
        selectedProvider={convertPublicProfileToSelectedProviderType(profile, states)}
        onScheduleSession={() => {
          return;
        }}
        isPublicProfile
        isPreview
      />
    </Box>
  );
};
